import { frw } from '@sfidanza/tahr';

let page;

export const login = new frw.Template();

login.onCreate = function (i18nRepository, pageRef) {
	this.i18n = i18nRepository;
	this.autoBindEvents = ['onclick'];
	page = pageRef;
};

login.onParse = function (backTo) {
	this.backTo = backTo || 'bet';
	this.set('backTo', this.backTo);
};

login.submit = function (id, pwd) {
	this.cleanErrors();
	if (!id) {
		this.setError('user_id');
	} else if (!pwd) {
		this.setError('user_pwd');
	} else {
		page.login({
			id: id,
			pwd: pwd
		}, page.select.bind(page, this.backTo));
	}
};

login.setError = function (fieldId) {
	const field = document.forms['signin-form'][fieldId];
	if (field) {
		field.classList.add('error');
	}
};

login.cleanErrors = function () {
	const fields = document.forms['signin-form'].querySelectorAll('.error');
	for (const field of fields) {
		field.classList.remove('error');
	}
};

login.signinGoogle = function (button) {
	window.open(' about:blank', 'signin', 'height=600,width=450'); // create the 'signin' popup on user action, or it will get blocked in the async process
	button.classList.add('waiting');
	fetch(page.config.url.auth('google'))
		.then(response => response.json())
		.then(data => {
			if (data && data.url) {
				//const wh = 
				window.open(data.url, 'signin');
				// should check wh to handle fail/cancel cases
			}
		});
};

login.signinCallback = function (query) {
	const params = new URLSearchParams(query);
	const code = params.get('code');
	if (code) {
		fetch(page.config.url.authProfile(code))
			.then(response => response.json())
			.then(data => {
				const button = document.getElementById('social-signin').querySelector('.signin-google');
				button.classList.remove('waiting');
				page.refreshUser(data, page.select.bind(page, this.backTo));
			});
	}
};
